import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { CzMaxPrice } from './CzMaxPrice';
import { ErrorResponse } from './ErrorResponse';
import { mapCzMaxPrice } from './mapCzMaxPrice';

export interface Result {
	czMaxPrice: CzMaxPrice;
}

export function findCzMaxPrice(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-max-price');
	return client
		.fetch(url.expand({ userId, groupId }))
		.then((response) => response.json())
		.then((response) => ({
			czMaxPrice: mapCzMaxPrice(response.czMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
